import { render, staticRenderFns } from "./base-prefixed-input.vue?vue&type=template&id=8025e616&scoped=true&"
import script from "./base-prefixed-input.vue?vue&type=script&lang=js&"
export * from "./base-prefixed-input.vue?vue&type=script&lang=js&"
import style0 from "./base-prefixed-input.vue?vue&type=style&index=0&id=8025e616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8025e616",
  null
  
)

export default component.exports